import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const CrmPage = () => import('./pages/CrmPage.vue');
const CrmCalendarPage = () => import('./pages/CrmCalendarPage.vue');
const CrmSettingsPage = () => import('./pages/CrmSettingsPage.vue');
const CrmAiCallsPage = () => import('./pages/CrmAiCallsPage.vue');
const CrmTrackingsPage = () => import('./pages/CrmTrackingsPage.vue');
const CrmReportsPage = () => import('./pages/CrmReportsWrapperPage.vue');

const meta = {
    permissions: ['administrator', 'agent'],
    featureFlag: FEATURE_FLAGS.CRM,
};

const crmRoutes = {
    routes: [
        {
            path: frontendURL('accounts/:accountId/crm'),
            redirect: to => {
                return { name: 'crm_deals_index', params: to.params };
            },
        },
        {
            path: frontendURL('accounts/:accountId/crm/deals'),
            name: 'crm_deals_index',
            meta,
            component: CrmPage,
        },
        {
            path: frontendURL('accounts/:accountId/crm/deals/:dealId'),
            name: 'crm_deal_show',
            meta,
            component: CrmPage,
            props: true,
        },
        {
            path: frontendURL('accounts/:accountId/crm/tasks'),
            name: 'crm_tasks',
            meta,
            component: CrmCalendarPage,
        },
        {
            path: frontendURL('accounts/:accountId/crm/ai-calls'),
            name: 'crm_ai_calls',
            meta,
            component: CrmAiCallsPage,
        },
        {
            path: frontendURL('accounts/:accountId/crm/settings'),
            name: 'crm_settings',
            meta,
            component: CrmSettingsPage,
        },
        {
            path: frontendURL('accounts/:accountId/crm/trackings'),
            name: 'crm_trackings',
            meta,
            component: CrmTrackingsPage,
        },
        {
            path: frontendURL('accounts/:accountId/crm/reports'),
            name: 'crm_reports',
            meta,
            component: CrmReportsPage,
        },
        {
            path: frontendURL('accounts/:accountId/crm/detailed-reports'),
            redirect: to => {
                return { name: 'crm_reports', params: to.params };
            },
        },
        {
            path: frontendURL('accounts/:accountId/crm/follow-ups'),
            name: 'crm_follow_ups',
            meta,
            component: () => import('./pages/CrmFollowUpPage.vue'),
        },
        {
            path: frontendURL('accounts/:accountId/crm/forms'),
            name: 'crm_forms',
            meta,
            component: () => import('./pages/CrmFormsPage.vue'),
        },
    ],
};

export default crmRoutes;
